import { css } from 'lit';

export const oipBenefitStyle = css`
    .long-description {
        display: none;
    }
    .long-description--expanded {
        display: block;
    }
`;
